export default __webpack_public_path__ + "static/media/goodFirstIssue.5586437a.svg";